module.exports = __webpack_public_path__ + "img/rencai-bg.da3e869f.png";